import { useState, useEffect } from 'react';

/**
 * 响应式断点 Hook
 * 用于检测不同屏幕尺寸并提供响应式样式
 */
export const useResponsive = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowSize.width <= 768 || (windowSize.width <= 1024 && windowSize.height <= 500);
  const isTablet = !isMobile && windowSize.width <= 1024;
  const isDesktop = windowSize.width > 1024;

  // 通用响应式样式
  const styles = {
    // 容器样式
    container: {
      padding: isMobile ? '0' : '24px',
    },
    // 卡片样式
    card: {
      marginBottom: isMobile ? 12 : 24,
      borderRadius: isMobile ? 12 : 8,
    },
    cardBody: {
      padding: isMobile ? 12 : 24,
    },
    // 表单样式
    formItem: {
      marginBottom: isMobile ? 16 : 24,
    },
    // 按钮样式
    button: {
      height: isMobile ? 44 : 40,
      fontSize: isMobile ? 16 : 14,
    },
    buttonBlock: {
      width: isMobile ? '100%' : 'auto',
      height: isMobile ? 44 : 40,
      fontSize: isMobile ? 16 : 14,
    },
    // 输入框样式
    input: {
      fontSize: isMobile ? 16 : 14,
    },
    // 文字样式
    title: {
      fontSize: isMobile ? 18 : 20,
    },
    subtitle: {
      fontSize: isMobile ? 16 : 18,
    },
    label: {
      fontSize: isMobile ? 15 : 14,
    },
    text: {
      fontSize: isMobile ? 14 : 15,
    },
    small: {
      fontSize: isMobile ? 13 : 12,
    },
    // 表格样式
    table: {
      fontSize: isMobile ? 13 : 14,
      scroll: isMobile ? { x: 'max-content' } : undefined,
    },
    // 间距
    spacing: {
      xs: isMobile ? 4 : 8,
      sm: isMobile ? 8 : 12,
      md: isMobile ? 12 : 16,
      lg: isMobile ? 16 : 24,
    },
  };

  return {
    isMobile,
    isTablet,
    isDesktop,
    windowSize,
    styles,
  };
};

export default useResponsive;
